import {useParams} from "react-router-dom";
import {Link as RouterLink} from "react-router-dom";

import {CircularProgress } from "@mui/material";
import Grid from '@mui/material/Grid2'

import Page from "../../components/Page";
import HelpTour from "../../components/HelpTour";
import useAuthenticatedRequest from "../../lib/useAuthenticatedRequest";
import {SITES_ROUTE} from "../../lib/routes";
import { useHelp } from "../../hooks/useHelpProvide";
import { BreadCrumbsCustom } from "../../components/BreadCrumbsCustom";
import CategoriesGrid from "./CategoriesGrid";
import helpSteps from "./helpSteps";

export default function Site() {
  const {siteId} = useParams();
  const [{isLoading, data, error}] = useAuthenticatedRequest({
    method: "GET",
    url: "categories",
    params: {siteID: siteId,},
  });

  const {tourVisible} = useHelp();

  function renderBody() {
    sessionStorage.removeItem("checkedVariables");
    sessionStorage.removeItem("selectedPeriod");
    if (isLoading) {
      return (
        <Grid container justify="center">
          <CircularProgress />
        </Grid>
      );
    }

    if (error) {
      return (
        <h1>{error}</h1>
      );
    }

    const configBradCrumbs = {
      Component:BreadCrumbsCustom,
      generalConfig:{
        RouterLink:RouterLink,
        typographyText:data.site.brand + " - " + data.site.name,
        linkConfig:[
          {
            to:SITES_ROUTE.path,
            textLink:"Home",
          },
        ]
      },
    }

    return (
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item size={12}>
          <configBradCrumbs.Component {...configBradCrumbs.generalConfig} {...configBradCrumbs.config}/>
        </Grid>

        <CategoriesGrid
          siteId={data.site.id}
          categories={
            data.cats_available_list.map(data => ({...data, available: true})).concat(
              data.cats_unavailable_list.map(data => ({...data, available: false}))
            )
          }
        />
      </Grid>
    );
  }

  return (
    <Page lastChildren={
      <HelpTour
        show={!isLoading && tourVisible}
        steps={helpSteps}/>
    }>
      {renderBody()}
    </Page>
  );
}

